export default __webpack_public_path__ + "static/media/galerie7.644104c0.jpg";